import React, { Component } from 'react';
import { Row, Col, Select } from 'antd';
import { urlapi, token, CheckTokenExp } from '../../config';

class StatusSend extends Component {
    constructor(props) {
        super(props);

        this.RequestSendStatus = this.RequestSendStatus.bind(this);
        this.onChangeSelect = this.onChangeSelect.bind(this);

        this.state = {
            statussend: "",
            sendlist: [],
        }
    }

    componentDidMount() {
        setTimeout(() => {
            this.RequestSendStatus()
        }, 10)
    }

    RequestSendStatus() {
        if (!CheckTokenExp()) {
            fetch(urlapi + "api/sendstatus", {
                method: 'get',
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    "Authorization": "Bearer " + token
                },
            }).then(
                function (data) {
                    if (data.ok) {
                        data.json().then(
                            function (json) {
                                this.setState({
                                    sendlist: json
                                });
                            }.bind(this)
                        );
                    }
                }.bind(this)
            ).catch(function () {
                Modal.error({
                    content: 'Error on the internal server',
                });
            }.bind(this));
        } else {
            this.props.history.push("/logout");
        }
    }

    onChangeSelect(value, e) {
        this.setState({ [e.props.name]: value });
        this.props.onchange(value)
    }

    render() {
        const Option = Select.Option
        const _send = this.state.sendlist
        return (
            <Select
                showSearch
                style={{ width: '100%' }}
                placeholder="SMS Status"
                optionFilterProp="children"
                onChange={this.onChangeSelect}
                value={this.state.statussend}
                filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
            >
                <Option name="statussend" value="">Status</Option>
                {_send.map((c, index) => (
                    <Option key={index} name="statussend" value={c.senD_ID}>
                        {c.senD_NAME}
                    </Option>
                ))}
            </Select>
        );
    }
}

export default StatusSend;



// WEBPACK FOOTER //
// ./src/views/Dropdown/StatusSend.js